import React from 'react';
import PropTypes from 'prop-types';
import Typography from './Typography.component';

const Badge = ({ 
	value = null, 
	steps = null, 
	totalSteps = null,
}) => {
	const isComplete = steps != null && totalSteps != null && steps === totalSteps;
	return (
		<div className={`common-ui-badge${isComplete ? ' complete' : ''}`}>
			<Typography.P className="bold">
				{value || `${steps}/${totalSteps}`}
			</Typography.P>
		</div>
	);
};

Badge.propTypes = {
	value: (props, propName, componentName) => {
		if (props.value != null && (props.steps != null || props.totalSteps != null)) {
			return new Error(
				`Invalid props combination in ${componentName}: Cannot provide both 'value' and 'steps'/'totalSteps'`
			);
		}
	},
	steps: (props, propName, componentName) => {
		if (props.steps != null && props.value != null) {
			return new Error(
				`Invalid props combination in ${componentName}: Cannot provide both 'steps' and 'value'`
			);
		}
		if (props.steps != null && typeof props.steps !== 'number') {
			return new Error(
				`Invalid prop '${propName}' of type '${typeof props.steps}' supplied to '${componentName}', expected 'number'`
			);
		}
	},
	totalSteps: (props, propName, componentName) => {
		if (props.totalSteps != null && props.value != null) {
			return new Error(
				`Invalid props combination in ${componentName}: Cannot provide both 'totalSteps' and 'value'`
			);
		}
		if (props.totalSteps != null && typeof props.totalSteps !== 'number') {
			return new Error(
				`Invalid prop '${propName}' of type '${typeof props.totalSteps}' supplied to '${componentName}', expected 'number'`
			);
		}
	},
};

export default Badge;

